import { Component, inject, Input } from '@angular/core';
import { FormArray, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { NZ_DRAWER_DATA, NzDrawerRef } from 'ng-zorro-antd/drawer';
import { AppCommon } from '../../providers/app-common';
import { VendorViewModel } from '../../models-views/vendor.view.model';
import { debounceTime, distinctUntilChanged, Subject, takeUntil,BehaviorSubject } from 'rxjs';
import { QuickAddService } from '../../services/quick-add.service';
import { NzMessageService } from 'ng-zorro-antd/message';
import {taxTypeResponseModal,vendorTypeRespModal} from '../../models/vendor.model'


@Component({
  selector: 'app-vendor-drawer',
  standalone: false,
  templateUrl: './vendor-drawer.component.html',
  styleUrl: './vendor-drawer.component.scss'
})

export class VendorDrawerComponent {
  data:any = inject(NZ_DRAWER_DATA)
  @Input() someInput!: string;
  form: FormGroup;
  categoryInput = '';
  loggedInUser:any
  countryList:any[] = []
  cityList:any[] = []
  stateList:any[] = []
  userList:any[] = []
  destroy$= new Subject()
  loading:boolean = false
  loadingMsg:string = 'Creating vendor...'
  isVisibleAddPoc = false;
  editPocData:any
  countryCodeList: any = []
  stateClearTimeOut:any
  cityClearTimeOut:any
  vendorTaxId : any = "";
  taxIdentificationTypes : any = [];
  vendorTypes : any [];
  taxTypeResponseModal = new BehaviorSubject<taxTypeResponseModal>(new taxTypeResponseModal());
  vendorTypeRespModal = new BehaviorSubject<vendorTypeRespModal>(new vendorTypeRespModal());


  constructor(private drawerRef: NzDrawerRef, private fb: FormBuilder,private vm:VendorViewModel,
    private message: NzMessageService, private quickAddService: QuickAddService) {
    this.vm.vendorDrawerComponent = this
    this.loggedInUser = AppCommon.getloggedInObject().user
    this.initForm()

    if(this.data?.vendor){
      this.updateForm();

      this.vm.vendorTypeRespModal
    .pipe(takeUntil(this.destroy$))
    .subscribe((d) => {
      this.vendorTypes = Array.isArray(d?.results) ? d.results : [];
    });
    }

    this.vm.countryCodeList.subscribe(data => {
      this.countryCodeList = data.results
    })
    this.vm.countryList.pipe(takeUntil(this.destroy$)).subscribe( d =>
      this.countryList = d.results
    )
    this.vm.stateList.pipe(takeUntil(this.destroy$)).subscribe( d =>
      this.stateList = d.results
    )
    this.vm.cityList.pipe(takeUntil(this.destroy$)).subscribe( d =>
      this.cityList = d.results
    )
    this.vm.userList.pipe(takeUntil(this.destroy$)).subscribe( d =>
      this.userList = d?.results
    )
    this.vm.getCountryList(1, 1000)
    this.vm.getUserList(1,5000)

    this.onContryChange()
    this.onStateChange()
    this.vm.getCountryCodeList()
    // Listen for changes in the 'website' input field
    this.form.get('website')?.valueChanges.subscribe((value) => {
      if (value && value.includes('https://')) {
        // Remove 'https://' from the input value
        const sanitizedValue = value.replace('https://', '');
        // Update the form control with the sanitized value
        this.form.get('website')?.setValue(sanitizedValue, { emitEvent: false });
      }
    });

    this.vm.taxTypeResponseModal
    .pipe(takeUntil(this.destroy$))
    .subscribe((d) => {
      this.taxIdentificationTypes = Array.isArray(d?.results) ? d.results : [];
    });

    this.vm.vendorTypeRespModal
    .pipe(takeUntil(this.destroy$))
    .subscribe((d) => {
      this.vendorTypes = Array.isArray(d?.results) ? d.results : [];
    });


    this.getVendorTypetax();

  }

  ngOnDestroy(): void {
    this.destroy$.next(true);
    this.destroy$.complete();
  }

  initForm(){
      this.form = this.fb.group({
      name: ['', [Validators.required, Validators.minLength(3)]],
      email: ['',[Validators.email]],
      phone_number: [''],
      country_code: [''],
      categories_serviced: [[]],
      notes: [''],
      country: [''],
      poc: [''],
      state: [''],
      city: ['', [Validators.required]],
      website: ['', [Validators.pattern(/^(https?:\/\/)?([\w-]+\.)+[\w-]{2,}(\/[^\s]*)?$/)]],
      address_1: ['',[Validators.required]],
      address_2: [''],
      registered_business_name: [''],
      vendor_type: [[], Validators.required],
      linkedin: [''],
      instagram: [''],
      tax_identification: ['', [Validators.required]],
       tax_input: ['']
    });
  }

  // updateForm(){

  //   let d = {
  //     name: this.data.vendor?.name,
  //     email: this.data.vendor?.email,
  //     phone_number: this.data.vendor?.phone_number,
  //     country_code: this.data.vendor?.country_code,
  //     // categories_serviced: this.data.vendor?.categories_serviced,
  //       vendor_type: this.data.vendor?.categories_serviced?.map((c:any) => c.id) || [],   // <-- map objects to IDs
  //     notes: this.data.vendor?.notes,
  //     country: this.data.vendor.city_details?.country_id,
  //     state: this.data.vendor.city_details?.state_id,
  //     poc: this.data.vendor.poc_details,
  //     city: this.data.vendor.city_details?.id,
  //     website: this.data.vendor?.website,
  //     address_1: this.data.vendor?.address_1,
  //     address_2: this.data.vendor?.address_2,
  //     registered_business_name: this.data.vendor?.registered_business_name,
  //     // vendor_type: this.data.vendor?.vendor_type,
  //     linkedin: this.data.vendor?.linkedin,
  //     instagram: this.data.vendor?.instagram,
  //     tax_identification: this.data.vendor?.tax_identification
  //   }
  //   this.form.patchValue(d,{emitEvent: true})

  //   if(this.data.vendor.id){
  //     this.vm.fetchVendorTax(this.data.vendor.id)
  //   }
  //  this.data.vendor.city_details?.country_id && this.vm.getStateListById(1,500,this.data.vendor.city_details.country_id)
  //  this.data.vendor.city_details?.state_id && this.vm.getCityListById(1,500,this.data.vendor.city_details.state_id)
  // }

// utils/url-utils.ts
  stripHttps(url: string | null | undefined): string {
    if (!url) return '';
    return url.replace(/^https?:\/\//, ''); // removes http:// or https://
  }


  updateForm() {
  let d = {
    name: this.data.vendor?.name,
    email: this.data.vendor?.email,
    phone_number: this.data.vendor?.phone_number,
    country_code: this.data.vendor?.country_code,
    vendor_type: this.data.vendor?.categories_serviced?.map((c:any) => c.id) || [],
    notes: this.data.vendor?.notes,
    country: this.data.vendor.city_details?.country_id,
    state: this.data.vendor.city_details?.state_id,
    poc: this.data.vendor.poc_details,
    city: this.data.vendor.city_details?.id,
    // website: this.data.vendor?.website,
    address_1: this.data.vendor?.address_1,
    address_2: this.data.vendor?.address_2,
    registered_business_name: this.data.vendor?.registered_business_name,
    // linkedin: this.data.vendor?.linkedin,
    // instagram: this.data.vendor?.instagram,
    website: this.stripHttps(this.data.vendor?.website),
    linkedin: this.stripHttps(this.data.vendor?.linkedin),
    instagram: this.stripHttps(this.data.vendor?.instagram)
  };

  this.form.patchValue(d, { emitEvent: true });

  // fetch states & cities
  if (this.data.vendor.city_details?.country_id) {
    this.vm.getStateListById(1, 500, this.data.vendor.city_details.country_id);
  }
  if (this.data.vendor.city_details?.state_id) {
    this.vm.getCityListById(1, 500, this.data.vendor.city_details.state_id);
  }

  // fetch tax info and patch separately
  if (this.data.vendor.id) {
    this.vm.fetchVendorTax(this.data.vendor.id, (taxData: any) => {
      this.form.patchValue({
        tax_identification: taxData.tax_type,
        tax_input: taxData.tax_input
      });
      this.vendorTaxId = taxData.id
    });
  }

  this.pocList =  this.data.vendor.poc_details
}

pocList :any = [];

  handleModelClose(): void {
    const resultData = { confirmed: true };
    this.drawerRef.close(resultData); // Triggers afterClose observable
    this.quickAddService.refreshData.next(true)
    this.loading = false;
  }

  // onContryChange() {
  //     this.form.get('country').valueChanges.subscribe( v => {
  //       this.form.get('state')?.setValue('')
  //       this.form.get('city')?.setValue('')
  //       this.vm.getStateListById(1,500,v)
  //     })
  // }

  onContryChange() {
    this.form.get('country').valueChanges.subscribe(countryId => {
      this.form.get('state')?.setValue(''); // reset state
      this.form.get('city')?.setValue('');  // reset city
      if (countryId) {
        this.vm.getStateListById(1, 500, countryId);
      }
    });
  }


  // onStateChange() {
  //     this.form.get('state').valueChanges.subscribe( v => {
  //       this.vm.getCityListById(1,500,v)
  //     })
  // }

  onStateChange() {
    this.form.get('state').valueChanges.subscribe(stateId => {
        this.form.get('city')?.setValue(''); // reset city
        if (stateId) {
          this.vm.getCityListById(1, 500, stateId);
        }
    });
  }



  onSearchState(e:any){
    clearTimeout(this.stateClearTimeOut)
    this.stateClearTimeOut = setTimeout(() => {
    if(e.length > 0){
        this.vm.getStateListById(1,500,this.form.get('country').value,e)
      }
    } , 400 )
  }


  onSearchCity(e:any){
    clearTimeout(this.cityClearTimeOut)
    this.cityClearTimeOut = setTimeout(() => {
      if(e.length > 0){
       this.vm.getCityListById(1,500,this.form.get('state').value,e)
    }

    } , 400 )

  }

  // onEmailChange(){
  //   this.form.get('email').valueChanges.subscribe( v => {

  //   })
  // }

  getCountryCode(id:number){
    return this.countryCodeList.find(el => el.id === id)?.code
  }

  openAddPoc() {
    this.isVisibleAddPoc = true;
    this.editPocData =undefined
  }

   editPOC(poc:any,e:any){
    e.preventDefault()
    this.editPocData = poc
    this.isVisibleAddPoc = true;
  }

  closeAddPocEvent(poc: any) {
    this.isVisibleAddPoc = false;
    this.editPocData =undefined
  }

  getIcon(name: string){
    return AppCommon.getDicebearIcon(name);
  }

  trackByPocId(index: number, poc: any): any {
    return poc.id || index; // Use a unique identifier
  }

  closeAddPoc(poc:any){
      if(poc && !this.editPocData) {
        const currentPocs = this.form.get('poc')?.value || [];
        this.form.get('poc')?.setValue([...currentPocs, poc ]);
      } else{
         const currentPocs = this.form.get('poc')?.value || [];
        const updatedPocs = currentPocs.map((item: any) =>
          item.id === poc.id ? { ...item, ...poc } : item
        );
        this.form.get('poc')?.setValue(updatedPocs);

      }
      this.isVisibleAddPoc = false;
      console.log(this.form.value)
    }



    // setupPOCListener() {
    //   this.form.get('poc')?.valueChanges.pipe(
    //     takeUntil(this.destroy$),
    //     distinctUntilChanged(),
    //     debounceTime(300)
    //   ).subscribe((value) => {
    //     if (!value || value.length === 0) return;

    //     // Case 1: Single entry - set type to 1
    //     if (value.length === 1) {
    //       const current = value[0];
    //       if (current.type !== 1) {
    //         const formData = {...current, type: 1};
    //         this.form.get('poc')?.patchValue([formData], { emitEvent: false });
    //       }
    //     }
    //     // Case 2: Multiple entries - set all to type 2
    //     else {
    //       const needsUpdate = value.some(item => item.type !== 2);
    //       if (needsUpdate) {
    //         const updatedValue = value.map(item => ({
    //           ...item,
    //           type: 2  // Set type to 2 for all in multiple entries
    //         }));
    //         this.form.get('poc')?.patchValue(updatedValue, { emitEvent: false });
    //       }
    //     }
    //   });
    // }


  addCategory(e:any) {
    e?.preventDefault()
    const value = this.categoryInput.trim();
    if (value) {
      const existing = this.form.get('categories_serviced')?.value || [];
      if (!existing.includes(value)) {
        this.form.get('categories_serviced')?.setValue([...existing, value]);
      }
      this.categoryInput = '';
    }
  }


  removeCategory(index: number): void {
    const categories = this.form.get('categories_serviced')?.value || [];
    categories.splice(index, 1);
    this.form.get('categories_serviced')?.setValue([...categories]);
  }

  markAllControlsAsTouched(control: any) {
  if (control instanceof FormGroup || control instanceof FormArray) {
    Object.keys(control.controls).forEach(key => {
      this.markAllControlsAsTouched(control.get(key));
    });
  } else {
    control.markAsTouched();
    control.markAsDirty();
  }
}

  onSubmit() {

    if (this.form.valid) {
      let d = this.form.value;

      if(!this.data?.vendor){
       if(d.poc){
          d.poc = d.poc?.filter(e => e.id == null)
       }
      }else {
        d.poc =[];
      }

      // if(d.poc){
      //    d.poc = d.poc?.filter(e => e.id == null)
      // }
      // d.website.length > 0 && (d.website = 'https://' + d.website);

      if (d.website && d.website.trim().length > 0) {
        if (!d.website.startsWith('http://') && !d.website.startsWith('https://')) {
          d.website = 'https://' + d.website;
        }
      }

      if (d.linkedin && d.linkedin.trim().length > 0) {
        if (!d.linkedin.startsWith('http://') && !d.linkedin.startsWith('https://')) {
          d.linkedin = 'https://' + d.linkedin;
        }
      }

      if (d.instagram && d.instagram.trim().length > 0) {
        if (!d.instagram.startsWith('http://') && !d.instagram.startsWith('https://')) {
          d.instagram = 'https://' + d.instagram;
        }
      }

      d.categories_serviced = d.vendor_type.map((id: number) => {
       const typeObj = this.vendorTypes.find(t => t.id === id);
       return typeObj ? { id: typeObj.id, name: typeObj.name } : null;
      }).filter(Boolean); // remove nulls if any

        // d.categories_serviced = d.vendor_type
        // .map((id:any) => this.vendorTypes.find(t => t.id === id)?.name)
        // .filter(Boolean); // ["Restaurant", "Cafe", "Bar"]


      if(this.data?.vendor) {
        this.loading = true
        this.loadingMsg = 'Updating vendor...'
        d.id = this.data.vendor.id
        d.modified_by = this.loggedInUser.id;

        this.vm.updateVendor(d, (res) => {
            try {
              const vendorID = res?.id || this.data.vendor?.id; // fallback to existing
              const modifiedBy = this.loggedInUser.id;

              if (!vendorID) {
                throw new Error("Vendor ID not found in response");
              }

              const taxPayload = {
                tax_input: d.tax_input.toString(),
                created_by: res?.created_by || this.loggedInUser.id,
                modified_by: modifiedBy,
                vendor: vendorID,
                tax_type: d.tax_identification
              };

              try {
                this.vm.updateVendorTax(this.vendorTaxId, taxPayload); // 👈 call update instead of create
              } catch (taxError) {
                this.message.error("Failed to update vendor tax. Please try again.");
              }

            } catch (error) {
              this.message.error("Something went wrong while processing vendor update.");
            }
        });


       } else {
        this.loading = true
        this.loadingMsg = 'Creating vendor...'
        d.created_by = this.loggedInUser.id;

        this.vm.createVendor(d, (res) => {

          try {
            const vendorID = res?.id;
            const createdBy = res?.created_by || this.loggedInUser.id;

            if (!vendorID) {
              throw new Error("Vendor ID not found in response");
            }

            const taxPayload = {
              tax_input: d.tax_input,
              created_by: createdBy,
              modified_by: null,
              vendor: vendorID,
              tax_type: d.tax_identification
            };

            try {
              this.vm.createVendorTax(taxPayload);
            } catch (taxError) {
              this.message.error("Failed to create vendor tax. Please try again.");
            }

          } catch (error) {
            this.message.error("Something went wrong while processing tax data.");
          }
        });

      }

    } else {
      this.message.error('Please fill all required fields correctly');
      this.markAllControlsAsTouched(this.form);
    }
  }

  getVendorTypetax(){
    let page = 1;
    let page_size = 100;
  this.vm.getvendorType(page,page_size);
  this.vm.getvendorTax(page,page_size);
  }



}
